import { ScreenSize } from 'common_lib/types'
import { getScreenSize } from 'common_lib/utils'
import { EventActionsEnum, EventParams, sendEvent } from 'mobile_web/modules/logging/analytics'
import { GetScreensShowResponseSectionItems } from 'mytours-read-api-typescript'
import {
	ScreenSectionItem,
	SCREEN_SECTION_REMOTE_TYPE_VIMEO,
	SCREEN_SECTION_REMOTE_TYPE_YOUTUBE,
	SCREEN_SECTION_TYPE_WEB_VIDEO,
} from 'mytours-read-common'
import ReactPlayer from 'react-player'

export const ReactPlayerConfig = {
	youtube: {
		playerVars: {
			showinfo: 0,
			controls: 1,
		},
	},
	vimeo: {
		playerOptions: {
			showinfo: 0,
			controls: 1,
		},
	},
}

export const isRemoteVideo = (remoteType: GetScreensShowResponseSectionItems.RemoteTypeEnum): boolean =>
	[SCREEN_SECTION_REMOTE_TYPE_YOUTUBE, SCREEN_SECTION_REMOTE_TYPE_VIMEO].includes(remoteType)

export const getVideoUrl = (videoFilePath: string, sectionItem: ScreenSectionItem): string => {
	const { remote_type: remoteType, media_type: mediaType, remote_id: remoteId, start_time: startTime } = sectionItem
	let url = videoFilePath
	const isYouTubeVideo = remoteType === SCREEN_SECTION_REMOTE_TYPE_YOUTUBE
	const isVimeoVideo = remoteType === SCREEN_SECTION_REMOTE_TYPE_VIMEO

	//TODO add webvideo type
	if (mediaType === SCREEN_SECTION_TYPE_WEB_VIDEO) {
		if (isYouTubeVideo) {
			url = `https://www.youtube.com/embed/${remoteId}${startTime ? `?start=${startTime}` : ''}`
		}

		if (isVimeoVideo) {
			url = `https://vimeo.com/${remoteId}${startTime ? `#t=${startTime}s` : ''}`
		}
	}

	return url
}

interface VideoAnalyticsEventProps {
	sectionItemName: string
	sectionId: number
	sectionTitle: string
	containerName: string
}
const sendVideoAnalyticsEvent = (
	player: ReactPlayer,
	props: VideoAnalyticsEventProps,
	action: EventActionsEnum,
	options: EventParams = {},
): void => {
	const { sectionItemName, sectionId, sectionTitle, containerName } = props
	const duration = player?.getDuration()

	const currentTime = player?.getCurrentTime()

	sendEvent(action, {
		videoDuration: duration,
		videoTitle: sectionItemName,
		videoCurrentTime: currentTime,
		videoPercent: options.videoPercent || Math.round((100 * currentTime) / duration) || 0,

		// TODO: ask if we need collection
		// collection: collection && collection.name,
		itemName: containerName,
		screenSection: `${sectionId}-${sectionTitle}`,
	})
}

export const sendVideoPlayEvent = (player: ReactPlayer, props: VideoAnalyticsEventProps, isVideoStarted: boolean) => {
	if (isVideoStarted) {
		sendVideoAnalyticsEvent(player, props, EventActionsEnum.VideoResume)
	} else {
		sendVideoAnalyticsEvent(player, props, EventActionsEnum.VideoStart)
	}
}

export const sendVideoPauseEvent = (player: ReactPlayer, props: VideoAnalyticsEventProps) => {
	const currentTime = player?.getCurrentTime() || 0
	const duration = player?.getDuration() || 0

	const roundedCurrentTime = Math.round(10 * currentTime) / 10
	const roundedDuration = Math.round(10 * duration) / 10

	if (roundedCurrentTime === roundedDuration) {
		sendVideoAnalyticsEvent(player, props, EventActionsEnum.VideoComplete)
	} else {
		sendVideoAnalyticsEvent(player, props, EventActionsEnum.VideoPause)
	}
}

export const sendVideoProgressEvent = (
	player: ReactPlayer,
	props: VideoAnalyticsEventProps,
	playedSeconds: number,
	progressBreakpoints: Record<number, boolean>,
) => {
	const percent = Math.round(100 * playedSeconds)

	if (percent >= 10 && percent < 25 && !progressBreakpoints[10]) {
		sendVideoAnalyticsEvent(player, props, EventActionsEnum.VideoProgress, { videoPercent: 10 })
		progressBreakpoints[10] = true
	} else if (percent >= 25 && percent < 50 && !progressBreakpoints[25]) {
		sendVideoAnalyticsEvent(player, props, EventActionsEnum.VideoProgress, { videoPercent: 25 })
		progressBreakpoints[25] = true
	} else if (percent >= 50 && percent < 75 && !progressBreakpoints[50]) {
		sendVideoAnalyticsEvent(player, props, EventActionsEnum.VideoProgress, { videoPercent: 50 })
		progressBreakpoints[50] = true
	} else if (percent >= 75 && percent < 100 && !progressBreakpoints[75]) {
		sendVideoAnalyticsEvent(player, props, EventActionsEnum.VideoProgress, { videoPercent: 75 })
		progressBreakpoints[75] = true
	}
}

export const getImageHeight = (screenSize: ScreenSize = getScreenSize()): number => {
	switch (screenSize) {
		case ScreenSize.lg:
		case ScreenSize.md: {
			return 318
		}
		case ScreenSize.sm:
		case ScreenSize.xs:
		default: {
			return 212
		}
	}
}
